import { Props } from "./Users.type";
import React, { useEffect } from "react";
import { Loading } from "../../components/common/Loading/Loading";
import { Protected } from "@/components/layout/Protected";
import { Box, Button, Container, createTheme, Divider, FormControlLabel, Grid, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ThemeProvider, Typography } from "@mui/material";
import { esES } from "@mui/material/locale";
import { PencilIcon } from "@/toolbox/constants/icons";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Popup } from "../Editor/components/Popup";
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';
import { userService } from "@/service/services/User.service";
import { AddUsuario } from "./components/AddUsuario";
import { useLocalStorage } from '@/toolbox/hooks/local-storage.hook';
import { KEY_USER_DATA } from '@/toolbox/constants/local-storage';

const theme = createTheme(
    {
        palette: {
            primary: { main: '#1976D2' },
        },
    },
    esES,
);

export const Users: React.FC<Props> = (props: Props): JSX.Element => {

    const [loading, setLoading] = React.useState<boolean>(false);
    const [users, setUsers] = React.useState([]);

    const [selectedUsers, setSelectedUser] = React.useState('');

    const [openPopup, setOpenPopup] = React.useState<boolean>(false);
    const [popUp, setPopUp] = React.useState<String>('');
    const [editMode, setEditMode] = React.useState<boolean>(false);

    const [dataUser] = useLocalStorage(KEY_USER_DATA, undefined);
    const rol = dataUser && dataUser.user.rol;
    const isSuperAdmin = rol === 'Superadmin';

    useEffect(() => {
        getUsers();
    }, [])


    const getUsers = async() => {
        setLoading(true);
        await userService.getUsers().then((data) =>{
            setUsers(data);
            setLoading(false);
        })
    }

    const funcionSwitch = async(user) =>{
        setLoading(true);
        if(user.state === 1){
            await userService.editState(user.id, 0);
        }else{
            await userService.editState(user.id, 1);
        }
        getUsers();
    }

    return (
        <Protected>
            {loading && <Loading/>}
            <Container maxWidth='xl' sx={{ mt: 1, mb: 2 }}>
                <Grid container justifyContent='space-between' spacing={2}>
                        <Grid item>
                            <Typography variant='h4' >Gestión de Usuarios</Typography>
                        </Grid>
                        <Grid item>
                            <Button variant='outlined' style={{textTransform: "capitalize"}}
                            onClick={()=>{
                                setOpenPopup(true);
                                setEditMode(true);
                                setPopUp('addUsuario');
                            }}
                            >Crear Usuario</Button>
                        </Grid>
                </Grid>

                <Divider sx={{ mt: 2 }} />

                <Grid container spacing={1} >
                    <Grid item xs={12}>
                        <Typography variant="body2" sx={{ mt: '20px' }} >
                            {
                                (users.length)  ? `${users.length} registros encontrados`
                                    : `0` && !loading
                            }
                        </Typography>
                    </Grid>
                </Grid>

                <Grid>
                    {
                        !loading && users.length > 0 && (
                            <Box sx={{Width: '100%', marginTop:'30px'}}>
                                <TableContainer component={Paper}>
                                    <ThemeProvider theme={theme}>
                                        <Table aria-label="simple table" size='small'>
                                            <TableHead>
                                                <TableRow  sx={{ bgcolor:'#1976D2'}}>
                                                    <TableCell sx={{ color: 'white' }} >
                                                        <strong>N°</strong>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ color: 'white' }} >
                                                        <strong>Nombre</strong>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ color: 'white' }} >
                                                        <strong>Usuario</strong>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ color: 'white' }} >
                                                        <strong>Email</strong>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ color: 'white' }} >
                                                        <strong>RUT</strong>
                                                    </TableCell>
                                                    {
                                                        isSuperAdmin && (
                                                            <TableCell align='center' sx={{ color: 'white' }} >
                                                                <strong>Empresa</strong>
                                                            </TableCell>
                                                        )
                                                    }
                                                    <TableCell align='center' sx={{ color: 'white' }} >
                                                        <strong>Sucursal</strong>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ color: 'white' }} >
                                                        <strong>Estado</strong>
                                                    </TableCell>

                                                    <TableCell align='center' sx={{ color: 'white' , minWidth:'8rem', maxWidth:'12rem'}}><strong>Acciones</strong></TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {
                                                    users.map((user, id) =>(
                                                        <TableRow key={id}>
                                                            <TableCell component="th" scope="row">
                                                                {id+1}
                                                            </TableCell>
                                                            <TableCell component="th" scope="row">
                                                                {user.nombre?.toLowerCase()}
                                                            </TableCell>
                                                            <TableCell align='center' component="th" scope="row">
                                                                {user?.usuario}
                                                            </TableCell>
                                                            <TableCell align='center' component="th" scope="row">
                                                                {user?.email}
                                                            </TableCell>
                                                            <TableCell align='center' component="th" scope="row">
                                                                {user?.rut}
                                                            </TableCell>
                                                            {
                                                                isSuperAdmin && (
                                                                    <TableCell align='center' component="th" scope="row">
                                                                        {user?.sucursales?.empresa?.name}
                                                                    </TableCell>
                                                                )
                                                            }
                                                            <TableCell align='center' component="th" scope="row">
                                                            {user?.sucursales?.nombre}
                                                            </TableCell>
                                                            <TableCell align='center' component="th" scope="row">
                                                                <Box>
                                                                <FormControlLabel
                                                                    control={<Switch onClick={() => {
                                                                        funcionSwitch(user);
                                                                    }}
                                                                />}
                                                                checked={user.state === 1 ? true : false}
                                                                label=""
                                                                />
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell align='center'>
                                                                <Button
                                                                    onClick={() =>  {
                                                                        setOpenPopup(true);
                                                                        setEditMode(true);
                                                                        setPopUp('editUsuario');
                                                                        setSelectedUser(user);
                                                                    }}
                                                                >
                                                                    <PencilIcon/>
                                                                </Button>

                                                                <Button
                                                                    onClick={() =>  {
                                                                        setOpenPopup(true);
                                                                        setEditMode(false);
                                                                        setPopUp('detailUsuario');
                                                                        setSelectedUser(user);
                                                                    }}
                                                                >
                                                                    <VisibilityIcon/>
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </ThemeProvider>
                                </TableContainer>
                            </Box>
                        )
                    }
                    {
                        !loading && users.length === 0 &&
                            <Grid container justifyContent="center">
                                <Box sx={{marginTop: '50px'}}>
                                <Grid container justifyContent="center"> <ContentPasteOffIcon className="iconocarrito"/></Grid>
                                    <Box sx={{Width: '100%', marginBottom:'30px', textAlign:'center'}}>No hay usuarios registrados</Box>
                                </Box>
                            </Grid>

                    }
                    {loading &&
                     <Box sx={{backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px', height:'100px'}}>
                     </Box>
                    }
                </Grid>
            </Container>
            {
                popUp === 'addUsuario' && (
                    <Popup
                        largo="sm"
                        title = 'Agregar Usuario'
                        openPopup = {openPopup}
                        setOpenPopup = {setOpenPopup}
                    >
                        <AddUsuario
                            closeModal={() => {setOpenPopup(false)}}
                            onListUsuarios = {getUsers}
                            editMode = {editMode}
                        />

                    </Popup>
                )
            }
            {
                popUp === 'editUsuario' && (
                    <Popup
                        largo="sm"
                        title = 'Editar Usuario'
                        openPopup = {openPopup}
                        setOpenPopup = {setOpenPopup}
                    >
                        <AddUsuario
                            closeModal={() => {setOpenPopup(false)}}
                            usuario = {selectedUsers}
                            onListUsuarios = {getUsers}
                            editMode = {editMode}
                        />

                    </Popup>
                )
            }
            {
                popUp === 'detailUsuario' && (
                    <Popup
                        largo="sm"
                        title = 'Detalle Usuario'
                        openPopup = {openPopup}
                        setOpenPopup = {setOpenPopup}
                    >
                        <AddUsuario
                            closeModal={() => {setOpenPopup(false)}}
                            usuario = {selectedUsers}
                            editMode = {editMode}
                        />

                    </Popup>
                )
            }
        </Protected>
    );
}
